import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormControlLabel,
  CircularProgress,
  Snackbar,
  Dialog,
  Slide as SlideUp,
  IconButton,
  Button,
  Typography,
  Grid,
  TextField,
  Checkbox,
  Box,
} from '@mui/material';

import { Close } from '@mui/icons-material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import placeholderItem from 'styles/assets/placeholder/placeholder.gif';
import thubmBlue from 'styles/assets/thumb_blue.png';
import { getStoreItem } from 'js/library/utils/API/getStoreItem';
import createAnonymous from 'js/library/utils/API/createAnonymous';
import { downloadImage } from 'js/library/services/StorageManager.js';
import {
  cellPhoneMask,
  startMatomo,
  trackEventMatomoVisit,
  trackEventMatomoElementId,
  trackEventMatomo,
  getLastUserInfo,
} from 'js/library/utils/helpers';
import 'react-slideshow-image/dist/styles.css';

import AppBarPromotion from 'js/containers/ApplessPromotions/AppBar';
import FooterPromotion from 'js/containers/ApplessPromotions/Footer';
import EstablishmentInfo from 'js/containers/ApplessPromotions/EstablishmentInfo';
import { login } from 'js/library/utils/API/login';
import { setUserInfo_v1Default } from 'js/library/utils/API/setUserInfo_v1';
import { getVoucherTemplate } from 'js/library/utils/API/getVoucherTemplate.js';
import { QRCodeSVG } from 'qrcode.react';
import { processOrder } from 'js/library/utils/API/processOrder';
import cfac22 from 'js/library/utils/cfac22';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <SlideUp direction="up" ref={ref} {...props} />;
});

export default function ApplessPromotion() {
  const { t } = useTranslation();

  const applessTheme = createTheme({
    palette: {
      primary: {
        main: '#fff',
      },
      secondary: {
        main: '#324996',
      },
    },
  });

  useEffect(() => {
    startMatomo();
    trackEventMatomoVisit('Resgate por link externo');
    document.title = 'Resgate por link externo';
  }, []);

  //buscando variáveis da URL
  const urlParams = new URLSearchParams(window.location.search);
  const storeId = urlParams.get('id');

  const [name, setName] = useState('');
  const [cellPhone, setCellPhone] = useState('');
  const [optin, setOptin] = useState(false);
  const [thumbnail, setThumbnail] = useState(placeholderItem);
  const [confimDialog, setConfimDialog] = useState(false);
  const [loadOrder, setLoadOrder] = useState(false);
  const [isOrdered, setIsOrdered] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackMessage, setSnackMessage] = useState(false);

  const [storeInfo, setStoreInfo] = useState(storeId === null ? false : null);
  const [establishmentInfo, setEstablishmentInfo] = useState(null);
  const [voucherTemplate, setVoucherTemplate] = useState(null);
  const [voucherInfo, setVoucherInfo] = useState(null);
  const [consumed, setConsumed] = useState(false);

  useEffect(() => {
    try {
      if (storeId !== null && storeInfo === null) {
        let userInfo = getLastUserInfo();

        async function fetchData() {
          if (userInfo === null) userInfo = await createAnonymous();

          getStoreItem(userInfo?.uId, storeId).then(async (dataReceived) => {
            if (dataReceived) {
              const voucherTemplate = await getVoucherTemplate(
                userInfo.uId,
                dataReceived.templateId
              );

              dataReceived.thumbnail = dataReceived.thumbnail.replace('triibomania-premios/', '');

              const folder = dataReceived.type === 'product' ? 'triibomania-premios' : 'promocao';

              downloadImage(folder, dataReceived.thumbnail)
                .then((result) => {
                  setThumbnail(result);
                })
                .catch((error) => {
                  return error;
                });

              const lastConsumption = localStorage.getItem('consumption|' + dataReceived.id);
              const consumed =
                (voucherTemplate.consumoUnico && lastConsumption !== null) ||
                Date.now() - parseInt(lastConsumption, 10) <= voucherTemplate.cooldown;

              setStoreInfo(dataReceived);
              setVoucherTemplate(voucherTemplate);
              setConsumed(consumed);

              getStoreItem(userInfo.uId, dataReceived.establishmentId).then((establishment) => {
                setEstablishmentInfo(establishment);
              });
            } else {
              setStoreInfo(false);
            }
          });
        }
        fetchData();
      }
    } catch (error) {
      setStoreInfo(false);
    }
  }, [storeId, storeInfo]);

  const handleChange = (name) => (event) => {
    //tracking matomo
    if (name === 'cellPhone') {
      setCellPhone(cellPhoneMask(event.target.value));
    } else {
      setName(event.target.value);
    }
  };

  const orderPromotion = async () => {
    if (cellPhone.length === 19 && optin) {
      setLoadOrder(true);

      try {
        const resultUser = await login('+' + cellPhone.replace(/\D/g, ''));
        const userInfo = {
          name: name,
          optInList: [
            {
              type: 'Termos de Uso da Triibo',
              optInId: '-Kzj_F6wDcfHkLMO_q4c',
              version: 1.0,
              dateAcceptance: Date.now(),
              accept: true,
            },
          ],
        };
        setUserInfo_v1Default(resultUser.data.userInfo.user.uId, ['setUserInfo'], userInfo, null);

        if (storeInfo.type === 'businessPartner') {
          setIsOrdered(true);
          window.location = storeInfo.url;
        } else {
          if (!storeInfo.autoValidate && !storeInfo.showQRCode) {
            localStorage.setItem('consumption|' + storeInfo.id, Date.now());

            const orderObject = {
              itemId: storeInfo.type === 'product' ? storeInfo.id : storeInfo.templateId,
              receiver: resultUser.data.userInfo.user.triiboId,
              requestDate: Date.now(),
              requestLat: 0,
              requestLon: 0,
              sender: resultUser.data.userInfo.user.triiboId,
              type: 'promotion',
            };

            processOrder(userInfo.uId, orderObject, false)
              .then((result) => {
                setLoadOrder(false);
                setConfimDialog(true);
                setIsOrdered(true);
                setVoucherInfo(result);
              })
              .catch((error) => {
                if (error === 'BLOCK_SIMULTANEOUS') {
                  setOpenSnackbar(true);
                  setSnackMessage('Você já possui um cupom desse tipo na carteira.');
                  setLoadOrder(false);
                } else {
                  setOpenSnackbar(true);
                  setSnackMessage('Ocorreu um erro ao resgatar essa promoção.');
                  setLoadOrder(false);
                }
              });
          } else {
            //promoção com validação de QRCode
            setOpenSnackbar(true);
            setSnackMessage('Essa promoção exige validação do estabelecimento.');
          }
        }
      } catch {
        //console.log('erro')
      }
    } else {
      setOpenSnackbar(true);
      setSnackMessage(
        cellPhone.length < 19
          ? 'Telefone celular inválido!'
          : 'Por favor, concorde com a Política de Privacidade.'
      );
    }
  };

  const downloadQrCode = () => {
    var link = document.createElement('a');
    link.download = voucherInfo.voucherId + '.png';
    link.href = document.getElementById('QRCode').toDataURL();
    link.click();
  };

  const printQrCode = () => {
    var dataUrl = document.getElementById('QRCode').toDataURL();

    const win = window.open('', 'PRINT', 'width=700,height=700');
    win.document.write('<body style="margin: 0;padding: 0;"');
    win.document.write(`<style type='text/css' media='print'>
             @page {
                size: auto;
                margin: 0;
            }           
            body, html {
                margin: 0;
                padding: 0;
                border: 0;
                background: #fff;
            }
            img {
                width: 397px;
                height: auto;
                max-width: 100%;
                margin: 0 auto;
                display: block;
            }
        </style>`);
    win.document.write(`<img src='${dataUrl}' onload='window.print()' />`);
    win.document.write('</body>');
    win.onfocus = () => {
      setTimeout(() => {
        win.close();
      }, 1000);
    };
  };

  return (
    <div id="scroll-matomo-applessPromotion" style={{ textAlign: '-webkit-center' }}>
      <ThemeProvider theme={applessTheme}>
        {storeInfo === null ? (
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            align="center"
            className="background-login"
            onLoad={() =>
              trackEventMatomoElementId('Resgate por link externo', 'visualizar', 'loading', '')
            }
          >
            <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>

            <Grid size={{ md: 4, sm: 6, xs: 10 }}>
              <CircularProgress color="secondary" />
              <Typography variant="h6">{t('general.wait_a_moment')}</Typography>
            </Grid>

            <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>
          </Grid>
        ) : storeInfo === false ? (
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            align="center"
            className="background-login"
            onLoad={() =>
              trackEventMatomoElementId('Resgate por link externo', 'visualizar', 'erro', '')
            }
          >
            <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>

            <Grid size={{ md: 4, sm: 6, xs: 10 }}>
              <Typography variant="h6">{t('errors.try_later')}</Typography>
              <a href={cfac22('homepage')} style={{ textDecoration: 'none' }}>
                <Button variant="contained" color="secondary" style={{ textTransform: 'none' }}>
                  {t('general.go_back_triibo')}
                </Button>
              </a>
            </Grid>

            <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>
          </Grid>
        ) : (
          <>
            <Box sx={{ display: { lg: 'block', md: 'block', sm: 'block', xs: 'none' } }}>
              <AppBarPromotion
                onClick={() =>
                  trackEventMatomoElementId('Resgate por link externo', 'tocar', 'menu', '')
                }
                establishmentName={storeInfo.establishmentName}
              />
            </Box>

            <div
              id="formulario-resgate"
              style={{
                backgroundColor: '#324996',
                width: '100%',
                padding: '30px 0px',
                textAlign: '',
              }}
            >
              <div className="card-promotion">
                <Grid container spacing={0} style={{ padding: '20px' }}>
                  <Box sx={{ display: { lg: 'none', md: 'none', sm: 'none', xs: 'block' } }}>
                    <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5 }} style={{ padding: '40px' }}>
                      <Typography
                        variant="h5"
                        color="secondary"
                        style={{
                          fontWeight: 'bolder',
                          paddingBottom: '10px',
                        }}
                        onClick={() =>
                          trackEventMatomoElementId(
                            'Resgate por link externo',
                            'tocar',
                            'title',
                            ''
                          )
                        }
                      >
                        {storeInfo.establishmentName}
                      </Typography>

                      <img
                        src={thumbnail}
                        width="100%"
                        alt="imagem da promoção"
                        onClick={() =>
                          trackEventMatomoElementId(
                            'Resgate por link externo',
                            'tocar',
                            'img-thumb',
                            ''
                          )
                        }
                      />
                      <Typography
                        variant="h5"
                        color="secondary"
                        style={{
                          fontWeight: 'bolder',
                          padding: '10px 0px',
                        }}
                        onClick={() =>
                          trackEventMatomoElementId(
                            'Resgate por link externo',
                            'tocar',
                            'title',
                            ''
                          )
                        }
                      >
                        {storeInfo.title}
                      </Typography>

                      <Typography
                        onClick={() =>
                          trackEventMatomoElementId(
                            'Resgate por link externo',
                            'tocar',
                            'description',
                            ''
                          )
                        }
                        variant="body2"
                        style={{
                          whiteSpace: 'pre-line',
                          paddingBottom: '10px 0px',
                          color: '#3C3C3C',
                          lineHeight: '1',
                        }}
                      >
                        {storeInfo.description}
                      </Typography>
                    </Grid>
                  </Box>

                  <Grid size={{ xs: 12, sm: 12, md: 7, lg: 7 }}>
                    <Box sx={{ display: { lg: 'none', md: 'none', sm: 'none', xs: 'block' } }}>
                      <Grid
                        container
                        alignItems="center"
                        align="center"
                        style={{ paddingBottom: '40px' }}
                      >
                        <Grid size={{ xs: 2, sm: 1 }}>
                          <img src={thubmBlue} width="100%" alt="thumb" />
                        </Grid>
                        <Grid size={{ xs: 10, sm: 11 }}>
                          <Typography
                            variant="h6"
                            color="secondary"
                            style={{ fontWeight: 'bolder' }}
                          >
                            {t('general.triibo_secure_environment')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    {consumed || isOrdered ? (
                      <div>
                        <Typography variant="h5" color="secondary" style={{ fontWeight: 'bolder' }}>
                          {t('general.coupon_redeemed_successfully')}
                        </Typography>

                        <Button
                          variant="contained"
                          size="large"
                          color="secondary"
                          style={{
                            textTransform: 'none',
                            marginTop: '10px',
                            borderRadius: '100px',
                          }}
                          onClick={() => {
                            trackEventMatomo(
                              'Resgate por link externo',
                              'tocar',
                              'botao',
                              'Ver cupom'
                            );
                            setConfimDialog(true);
                          }}
                        >
                          Ver cupom
                        </Button>
                      </div>
                    ) : (
                      <>
                        <Typography variant="h6" color="secondary" style={{ fontWeight: 'bolder' }}>
                          {t('general.fill_the_infos_below_to_receive_the_qr_code')}
                        </Typography>

                        <div style={{ padding: '20px' }}>
                          <form onSubmit={() => orderPromotion()}>
                            <TextField
                              onBlur={() =>
                                trackEventMatomo(
                                  'Resgate por link externo',
                                  'digitar',
                                  'name',
                                  name
                                )
                              }
                              id="name-appless"
                              variant="outlined"
                              fullWidth
                              required
                              type="text"
                              value={name}
                              label={t('general.name')}
                              onChange={handleChange('name')}
                              color="secondary"
                            />

                            <TextField
                              onBlur={() =>
                                trackEventMatomo(
                                  'Resgate por link externo',
                                  'digitar',
                                  'cellPhone',
                                  cellPhone
                                )
                              }
                              id="cellphone-appless"
                              variant="outlined"
                              fullWidth
                              required
                              type="tel"
                              value={cellPhone}
                              label={t('general.phone_number')}
                              onChange={handleChange('cellPhone')}
                              style={{ marginTop: '10px' }}
                              color="secondary"
                            />

                            <FormControlLabel
                              id="optin"
                              control={
                                <Checkbox
                                  style={{ color: '#3c3c3c' }}
                                  checked={optin}
                                  onChange={() => {
                                    setOptin(!optin);
                                    trackEventMatomo(
                                      'Resgate por link externo',
                                      'digitar',
                                      'optin',
                                      !optin
                                    );
                                  }}
                                  value="optin"
                                />
                              }
                              label={
                                <p
                                  style={{
                                    fontSize: '17px',
                                    color: '#3C3C3C',
                                  }}
                                >
                                  {t('general.read_and_agree_terms')}
                                </p>
                              }
                            />

                            <Button
                              disabled={loadOrder || voucherTemplate === null}
                              type="submit"
                              variant="contained"
                              size="large"
                              color="secondary"
                              style={{
                                textTransform: 'none',
                                marginTop: '10px',
                                borderRadius: '100px',
                              }}
                              onClick={() =>
                                trackEventMatomo(
                                  'Resgate por link externo',
                                  'tocar',
                                  'botao',
                                  'Resgate agora!'
                                )
                              }
                            >
                              {loadOrder || voucherTemplate === null ? (
                                <CircularProgress />
                              ) : (
                                t('general.redeem_now')
                              )}
                            </Button>
                          </form>
                        </div>
                      </>
                    )}
                  </Grid>
                </Grid>
              </div>
            </div>

            {establishmentInfo !== null && (
              <EstablishmentInfo
                props={{
                  establishmentInfo: establishmentInfo,
                  storeInfo: storeInfo,
                  thumbnail: thumbnail,
                }}
              />
            )}

            {!consumed && (
              <div>
                <a href="#formulario-resgate" style={{ textDecoration: 'none' }}>
                  <Button
                    onClick={() =>
                      trackEventMatomoElementId(
                        'Resgate por link externo',
                        'tocar',
                        'botao',
                        'Resgate agora! - descrição'
                      )
                    }
                    variant="contained"
                    color="secondary"
                    style={{
                      textTransform: 'none',
                      borderRadius: '100px',
                      padding: '12px 40px',
                      marginBottom: '20px',
                    }}
                  >
                    {t('general.redeem_now')}
                  </Button>
                </a>
              </div>
            )}

            <FooterPromotion
              onClick={() =>
                trackEventMatomoElementId('Resgate por link externo', 'tocar', 'footer', '')
              }
            />
          </>
        )}

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={openSnackbar}
          onClose={() => setOpenSnackbar(false)}
          ContentProps={{ 'aria-describedby': 'message-id' }}
          message={<span id="message-id">{snackMessage}</span>}
        />

        <Dialog
          open={confimDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setConfimDialog(false)}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          align="center"
        >
          <div>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                setConfimDialog(false);
                trackEventMatomo('Resgate por link externo', 'tocar', 'modal', 'close-modal');
              }}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </div>
          <div>
            <div style={{ width: '90%' }}>
              <Grid container style={{ padding: '5px 30px 10px 30px' }}>
                <Grid size={{ xs: 12, sm: 12 }}>
                  {voucherTemplate && voucherInfo && (
                    <>
                      <Typography style={{ fontWeight: 'bolder' }} variant="h5">
                        {voucherTemplate.titulo}
                      </Typography>
                      <div style={{ padding: '20px 0px' }}>
                        <QRCodeSVG
                          onClick={() =>
                            trackEventMatomoElementId(
                              'Promoção de link externo',
                              'tocar',
                              'qrCode',
                              voucherInfo.voucherId
                            )
                          }
                          id="QRCode"
                          value={voucherInfo.voucherId}
                          size={140}
                          bgColor={'#ffffff'}
                          fgColor={'#000000'}
                          level={'M'}
                        />
                      </div>

                      <Typography
                        onClick={() =>
                          trackEventMatomoElementId(
                            'Promoção de link externo',
                            'tocar',
                            'coupon-code',
                            voucherInfo.voucherId
                          )
                        }
                        variant="h4"
                        color="secondary"
                        style={{ fontWeight: 'bolder' }}
                      >
                        <u>{voucherInfo.voucherId}</u>
                      </Typography>

                      <Typography
                        variant="subtitle2"
                        color="secondary"
                        style={{ fontWeight: 'bolder' }}
                      >
                        {t('general.to_redeem_enter_the_code_or_present_qr_code')}
                      </Typography>

                      <Grid container spacing={2} style={{ marginTop: '15px' }}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <Button
                            onClick={() => printQrCode()}
                            variant="outlined"
                            fullWidth
                            color="secondary"
                            style={{
                              textTransform: 'none',
                              borderRadius: '100px',
                            }}
                          >
                            <Typography variant="h6" style={{ textTransform: 'capitalize' }}>
                              {t('general.print')}
                            </Typography>
                          </Button>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6 }}>
                          <Button
                            onClick={() => downloadQrCode()}
                            variant="outlined"
                            fullWidth
                            color="secondary"
                            style={{
                              textTransform: 'none',
                              borderRadius: '100px',
                            }}
                          >
                            <Typography variant="h6" style={{ textTransform: 'capitalize' }}>
                              {t('general.download')}
                            </Typography>
                          </Button>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        </Dialog>
      </ThemeProvider>
    </div>
  );
}

